<template>
  <div>
    <helpers-section-header class="mt-6 mb-8"> Insider Buying Signal Rules </helpers-section-header>

    <helpers-section-sub-header class="mt-6 mb-2"> Signal Evaluation: </helpers-section-sub-header>
    <v-row style="margin-top: 20px">
      <v-col v-if="!appcriteria.general.screener" cols="12">
        <v-text-field
          v-model="criteria.number_of_days_to_evaluate"
          label="Days to evaluate"
          suffix="days"
          variant="outlined"
          density="compact"
          hint="Number of days after filing released (plus trading delay) to continue to evaluate as a buy.  max days allowed is 100.  Max trading signals to evaluate is 200"
          persistent-hint
          style="max-width: 250px"
        />
      </v-col>
    </v-row>

    <v-tabs v-model="tab" theme="dark">
      <v-tab value="1"> Transactions Filter </v-tab>
      <v-tab value="2"> Insider Restrictions </v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="1">
        <TransactionsFilter />
      </v-tabs-window-item>
      <v-tabs-window-item value="2">
        <InsiderRestrictions />
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
// Modules
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { mapWritableState } from 'pinia'
import InsiderRestrictions from '@/components/page/whale-backtester/signals/_InsiderRestrictions'
import TransactionsFilter from '@/components/page/whale-backtester/signals/_TransactionsFilter'
import { markRaw } from 'vue'
export default {
  components: {
    TransactionsFilter: markRaw(TransactionsFilter),
    InsiderRestrictions: markRaw(InsiderRestrictions)
  },
  data() {
    return {
      tab: '1',
      allow_shorts: true,
      allow_longs: true,
      dialog: false,
      and_or: 'or'
    }
  },
  computed: {
    ...mapWritableState(useAppStore, ['whaleTraderCriteria', 'signalView', 'exit_time_periods']),
    criteria() {
      return this.whaleTraderCriteria.signals.insider_signal
    },
    appcriteria() {
      return this.whaleTraderCriteria
    },
    enabled() {
      return this.whaleTraderCriteria.signals.insider_signal.enabled
    }
    /*...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.insider_signal',
      enabled: 'app.whaleTraderCriteria.signals.insider_signal.enabled'
    })*/
  }
}
</script>
